<template>
  <div @click="handleClick" class="page__button_to-prev-page" :class="rootCss">
    <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
    <span>Вернуться обратно</span>
  </div>
</template>

<script>
export default {
  props: {
    locationFallbackLink: {
      type: String,
      default: "/cloths",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rootCss() {
      return {
        page__button_disabled: this.disabled,
      };
    },
  },
  methods: {
    handleClick() {
      this.$router.go(-1);
      this.$router.push(this.locationFallbackLink);
    },
  },
};
</script>

<style scoped>
.page__button_to-prev-page {
  display: inline-flex;
  column-gap: 0.5em;
  flex-direction: row;
  align-items: center;
  color: #337ab7;
}
.page__button_disabled {
  opacity: 0.5;
  transition: opacity 0.3s;
  pointer-events: none;
}
.page__button_to-prev-page:hover,
.page__button_to-prev-page:focus {
  cursor: pointer;
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/ui/PreviousPageButton.vue